import { render, staticRenderFns } from "./PublicProfileCard.vue?vue&type=template&id=5a67cc63&scoped=true&"
import script from "./PublicProfileCard.vue?vue&type=script&lang=js&"
export * from "./PublicProfileCard.vue?vue&type=script&lang=js&"
import style0 from "./PublicProfileCard.vue?vue&type=style&index=0&id=5a67cc63&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a67cc63",
  null
  
)

export default component.exports